import {
  IPayerResponse,
  IPayerUpdateRequest
} from "@wingspanhq/payments/dist/interfaces";
import { updatePayer } from "../../../services/payers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation, WSMutationConfig } from "../../helpers";
import { QUERY_PAYER_ROWS } from "../../search/payer/queries/useQueryPayerRows";
import { QUERY_PAYER_ROWS_SUMMARY } from "../../search/payer/queries/useQueryPayerRowsSummary";
import { QUERY_ALL_PAYER_LIST, QUERY_PAYER } from "../keys";

export const useUpdatePayer = (
  config?: WSMutationConfig<
    IPayerResponse,
    WSServiceError,
    IPayerUpdateRequest & { id: string }
  >
) =>
  useWSMutation<
    IPayerResponse,
    WSServiceError,
    IPayerUpdateRequest & { id: string }
  >(({ id, ...payload }) => updatePayer(id, payload), {
    ...config,
    dependencies: [
      QUERY_ALL_PAYER_LIST,
      QUERY_PAYER,
      QUERY_PAYER_ROWS,
      QUERY_PAYER_ROWS_SUMMARY,
      ...(Array.isArray(config?.dependencies) ? config?.dependencies || [] : [])
    ]
  });
